
<template>
  <div
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="{ 'active-dropzone': active }"
    class="dropzone position-relative"
  >
    <label :for="inputFileId" class="bg-light text-dark stretched-link"><i class="display-4 text-muted ri-add-fill"></i></label>
   <input type="file" :id="inputFileId"  class="dropzoneFile btn btn-primary" :multiple="multiple" :accept="uploadType"/>
  </div>
</template>


<script>
import { ref } from "vue";
export default {
  name: "dropzone",
  setup() {
    const active = ref(false);
    const toggleActive = () => {
      active.value = !active.value;
    };
    return { active, toggleActive };
  },
  props: {
    inputFileId: {
      type: String,
      default: 'dropzoneFile'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    uploadType:{
      type: String,
      default: ''
    }
  }
};
</script>
